module.exports = __webpack_public_path__ + "static/media/pause.9fe28c05.svg";